export default {
  agate: 1,
  androidstudio: 1,
  'arduino-light': 1,
  arta: 1,
  ascetic: 1,
  'atom-one-dark': 1,
  'atom-one-light': 1,
  'brown-paper': 1,
  'codepen-embed': 1,
  'color-brewer': 1,
  dark: 1,
  default: 1,
  docco: 1,
  far: 1,
  foundation: 1,
  github: 1,
  googlecode: 1,
  grayscale: 1,
  hybrid: 1,
  idea: 1,
  'ir-black': 1,
  magula: 1,
  'mono-blue': 1,
  'monokai-sublime': 1,
  monokai: 1,
  obsidian: 1,
  'paraiso-dark': 1,
  'paraiso-light': 1,
  pojoaque: 1,
  purebasic: 1,
  rainbow: 1,
  routeros: 1,
  'school-book': 1,
  sunburst: 1,
  'tomorrow-night-blue': 1,
  'tomorrow-night-bright': 1,
  vs: 1,
  vs2015: 1,
  xcode: 1,
  xt256: 1,
  'a11y-dark': 1,
  'a11y-light': 1,
  'an-old-hope': 1,
  'atom-one-dark-reasonable': 1,
  'brown-pap': 1,
  devibeans: 1,
  'github-dark': 1,
  'github-dark-dimmed': 1,
  gml: 1,
  'gradient-dark': 1,
  'gradient-light': 1,
  'isbl-editor-dark': 1,
  'isbl-editor-light': 1,
  'kimbie-dark': 1,
  'kimbie-light': 1,
  lightfair: 1,
  lioshi: 1,
  'night-owl': 1,
  'nnfx-dark': 1,
  'nnfx-light': 1,
  nord: 1,
  pojo: 1,
  'qtcreator-dark': 1,
  'qtcreator-light': 1,
  'shades-of-purple': 1,
  srcery: 1,
  'stackoverflow-dark': 1,
  'stackoverflow-light': 1
};



// WEBPACK FOOTER //
// ./src/lib/core/hljs/lang.hljs.css.js